// 每日看瓜 —— 站点内容数据（题材虚构，仅用于演示热门事件围观社区）
export const CATEGORIES = ["全部", "娱乐", "职场", "社会", "生活", "科技", "网络"] as const;

export type GuaItem = {
  id: string;
  title: string;
  summary: string;
  category: string;
  tags: string[];
  time: string;
  likes: number;
  comments: number;
  isNew?: boolean;
  emoji: string;
};

export const GUA_FEED: GuaItem[] = [
  {
    id: "g01",
    title: "顶流乐队巡演门票秒空，黄牛喊价十倍仍有人排队求票",
    summary: "开票三分钟全部售罄，二手平台出现大量高价转票，真粉集体吐槽难抢，主办方深夜发声明回应加场传闻。",
    category: "娱乐",
    tags: ["演唱会", "黄牛", "加场"],
    time: "2小时前",
    likes: 3241,
    comments: 1887,
    isNew: true,
    emoji: "🎤",
  },
  {
    id: "g02",
    title: "某大厂年终奖发放规则调整，员工连夜开会讨论去留",
    summary: "网传内部邮件流出，绩效系数与奖金包计算方式变更引发热议，网友纷纷晒出自己公司年终奖做对比。",
    category: "职场",
    tags: ["大厂", "年终奖", "内卷"],
    time: "4小时前",
    likes: 5210,
    comments: 3420,
    isNew: true,
    emoji: "🏢",
  },
  {
    id: "g03",
    title: "小区楼下新开网红烤冷面摊，凌晨两点还在排队是什么水平",
    summary: "博主探店视频刷屏，号称吃过一次就戒不掉，评论区吵翻究竟是营销还是真香，本地人实测整活。",
    category: "生活",
    tags: ["美食", "探店", "排队"],
    time: "6小时前",
    likes: 1988,
    comments: 1023,
    emoji: "🍜",
  },
  {
    id: "g04",
    title: "新发布旗舰手机摄像头参数被扒，结果网友全在关注电量",
    summary: "发布会热度被续航话题抢走，多个测评博主晒出实测数据，续航焦虑成为全场最大讨论点。",
    category: "科技",
    tags: ["手机", "发布会", "续航"],
    time: "9小时前",
    likes: 2780,
    comments: 1564,
    emoji: "📱",
  },
  {
    id: "g05",
    title: "地铁上让座反被嫌慢，阿姨一句话把全网惹毛了",
    summary: "视频记录全程冲突，当事人发长文还原经过，网友讨论让座边界与文明礼仪，两派观点吵得不可开交。",
    category: "社会",
    tags: ["让座", "地铁", "冲突"],
    time: "11小时前",
    likes: 8602,
    comments: 6311,
    emoji: "🚇",
  },
  {
    id: "g06",
    title: "百万粉情感博主翻车现场：台词竟被扒出全文照抄段子手",
    summary: "细心的网友逐帧对比，发现博主多条金句疑似从冷门博主文案里拼接，原作者亲自下场回应。",
    category: "网络",
    tags: ["博主", "抄袭", "翻车"],
    time: "13小时前",
    likes: 7410,
    comments: 5088,
    emoji: "💬",
  },
  {
    id: "g07",
    title: "同事天天蹭我外卖备注加菜，一句'顺手的事'把我整不会了",
    summary: "职场社交边界话题又引共鸣，网友纷纷分享被同事'合理白嫖'的糟心经历，评论区成大型共情现场。",
    category: "职场",
    tags: ["同事", "外卖", "边界"],
    time: "1天前",
    likes: 4560,
    comments: 2977,
    emoji: "🥡",
  },
  {
    id: "g08",
    title: "宠物猫学会开冰箱后开始偷鱼，主人装监控记录犯罪全过程",
    summary: "一只自学成才的'惯犯猫'走红，主人无奈晒出监控截图，网友一边心疼鱼一边被猫的智商折服。",
    category: "生活",
    tags: ["宠物", "猫咪", "搞笑"],
    time: "1天前",
    likes: 9330,
    comments: 5120,
    emoji: "🐱",
  },
  {
    id: "g09",
    title: "AI绘画比赛闹乌龙，冠军作品竟被指是人工后期P上去的",
    summary: "赛事方公布结果后遭技术圈质疑，多张对比图流出，主办方宣布复核并暂停颁奖引发二次反转。",
    category: "科技",
    tags: ["AI", "比赛", "反转"],
    time: "1天前",
    likes: 6230,
    comments: 4019,
    emoji: "🤖",
  },
];

export type HotItem = {
  rank: number;
  title: string;
  heat: number;
  trend: "up" | "down" | "new";
  tag: string;
};

export const HOT_LIST: HotItem[] = [
  { rank: 1, title: "顶流演唱会门票秒空，黄牛疯狂加价", heat: 128.6, trend: "up", tag: "娱乐" },
  { rank: 2, title: "大厂年终奖规则调整引热议", heat: 115.2, trend: "up", tag: "职场" },
  { rank: 3, title: "地铁让座冲突全程视频曝光", heat: 103.4, trend: "new", tag: "社会" },
  { rank: 4, title: "百万粉博主被指文案抄袭", heat: 96.8, trend: "up", tag: "网络" },
  { rank: 5, title: "旗舰手机续航实测吵翻网友", heat: 88.1, trend: "down", tag: "科技" },
  { rank: 6, title: "网红烤冷面摊凌晨还排长队", heat: 79.5, trend: "up", tag: "生活" },
  { rank: 7, title: "宠物猫开冰箱偷鱼成'惯犯'", heat: 72.3, trend: "down", tag: "生活" },
  { rank: 8, title: "AI绘画大赛冠军作品遭质疑", heat: 65.9, trend: "new", tag: "科技" },
  { rank: 9, title: "职场'顺手帮个忙'的边界感", heat: 58.7, trend: "down", tag: "职场" },
  { rank: 10, title: "外卖备注加菜引发同事吐槽", heat: 51.2, trend: "down", tag: "职场" },
];

export type Episode = {
  ver: string;
  title: string;
  time: string;
  isNew?: boolean;
};

export type FollowUp = {
  id: string;
  title: string;
  emoji: string;
  category: string;
  episodes: Episode[];
};

export const FOLLOW_UPS: FollowUp[] = [
  {
    id: "f01",
    title: "顶流乐队加场传闻持续发酵",
    emoji: "🎸",
    category: "娱乐",
    episodes: [
      { ver: "第1期", title: "开票秒空，黄牛加价十倍", time: "3小时前" },
      { ver: "第2期", title: "主办方回应：确有加场计划", time: "2小时前", isNew: true },
      { ver: "蹲后续", title: "实名购票新政正在协商", time: "进行中", isNew: true },
    ],
  },
  {
    id: "f02",
    title: "大厂年终奖邮件真假调查",
    emoji: "🧧",
    category: "职场",
    episodes: [
      { ver: "第1期", title: "内部邮件截图流出", time: "1天前" },
      { ver: "第2期", title: "官方称'不实信息'", time: "10小时前" },
      { ver: "蹲后续", title: "员工陆续晒出新方案", time: "进行中", isNew: true },
    ],
  },
  {
    id: "f03",
    title: "地铁让座冲突后双方回应",
    emoji: "🚇",
    category: "社会",
    episodes: [
      { ver: "第1期", title: "完整视频在平台曝光", time: "昨天" },
      { ver: "第2期", title: "当事人双方发文回应", time: "8小时前" },
      { ver: "蹲后续", title: "评论区持续讨论边界", time: "进行中", isNew: true },
    ],
  },
  {
    id: "f04",
    title: "AI绘画大赛冠军争议复核",
    emoji: "🖌️",
    category: "科技",
    episodes: [
      { ver: "第1期", title: "冠军作品被指人工后期", time: "昨天" },
      { ver: "第2期", title: "主办方宣布暂停颁奖", time: "12小时前" },
      { ver: "蹲后续", title: "技术复核报告即将公布", time: "进行中", isNew: true },
    ],
  },
];

export type GodComment = {
  id: string;
  content: string;
  author: string;
  context: string;
  likes: number;
  hue: number;
};

export const GOD_COMMENTS: GodComment[] = [
  {
    id: "c01",
    content: "让座是情分不让是本分，但有的人一开口就把情分当债务催收，这谁顶得住。",
    author: "在下略懂",
    context: "地铁让座冲突",
    likes: 5213,
    hue: 18,
  },
  {
    id: "c02",
    content: "猫会开冰箱已经很离谱了，重点是它还会挑贵的鱼偷，这智商建议去当CEO。",
    author: "铲屎官本官",
    context: "宠物猫偷鱼",
    likes: 4301,
    hue: 148,
  },
  {
    id: "c03",
    content: "年终奖像开盲盒，别人是SSR我抽到个谢谢惠顾，还得假装很开心。",
    author: "卑微打工人",
    context: "年终奖话题",
    likes: 3892,
    hue: 40,
  },
  {
    id: "c04",
    content: "黄牛你们就别抢了，留点位置给真的会唱的朋友吧，求求了。",
    author: "非著名乐迷",
    context: "演唱会抢票",
    likes: 3577,
    hue: 200,
  },
];

export const FAQS = [
  {
    q: "每日看瓜是做什么的？",
    a: "每日看瓜是一个聚合娱乐、职场、社会、生活等领域热门事件的吃瓜围观社区，帮助网友快速找到最新瓜田现场、前排吃瓜并持续蹲后续进度。",
  },
  {
    q: "吃瓜和蹲后续是什么意思？",
    a: "吃瓜指围观讨论热门事件的最新进展，蹲后续则是持续跟进事件接下来是否反转、是否有新料更新，不错过任何反转细节。",
  },
  {
    q: "在哪里看热门事件排行榜？",
    a: "首页设有今日瓜榜，集中展示当前热度最高的热门事件话题，方便吃瓜群众快速锁定当下最有讨论度的事件。",
  },
  {
    q: "网友神评论在哪里看？",
    a: "每日看瓜精选网友神评论集中展示在神评墙栏目，用轻松有趣的方式呈现网友对热门事件的花式点评。",
  },
  {
    q: "追更订阅有什么用处？",
    a: "订阅每日看瓜追更动态后，可在新瓜上架、神反转出炉时第一时间收到推送提醒，不错过任何蹲后续的关键节点。",
  },
];

export const STATS = [
  { num: "128", label: "今日活跃话题" },
  { num: "56", label: "进行中蹲后续" },
  { num: "9.6w", label: "每日围观人次" },
  { num: "4.8", label: "瓜田满分热度" },
];